import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { packageContext } from '../../../../contexts/package/packageContext';
import { selectIsBuyPackageModalLoading } from '../../../../selectors/buyPackageModal';
import { buyPackageThunk } from '../../../../thunks';
import { closeBuyPackageModal } from '../../../../slices';
import { TAppState, TDispatch } from '../../../../types';
import { Actions } from './Actions';

export const ActionsContainer = () => {
  const isLoading = useSelector(selectIsBuyPackageModalLoading);

  const { getState } = useStore<TAppState>();

  const dispatch = useDispatch<TDispatch>();

  const handleCancel = React.useCallback(() => {
    const state = getState();
    packageContext.trackCancel(state);

    dispatch(closeBuyPackageModal());
  }, [dispatch, getState]);

  const handleConfirm = React.useCallback(() => {
    dispatch(buyPackageThunk());
  }, [dispatch]);

  const cancelButton = (
    <Button onClick={handleCancel} theme="fill_secondary" disabled={isLoading} data-testid="cancel-button">
      Отменить
    </Button>
  );

  const confirmButton = (
    <Button onClick={handleConfirm} loading={isLoading} data-testid="confirm-button">
      Оплатить
    </Button>
  );

  return <Actions cancel={cancelButton} confirm={confirmButton} />;
};
